import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';

/**
 * Shown to a logged-in account that has no role yet (JWT `Roles` claim is empty) - typically an OSK
 * that confirmed its e-mail and is waiting for the platform operator's approval. Roles are read from
 * the token, so the user has to sign in again once the operator grants access.
 */
@Component({
  selector: 'app-access-pending',
  standalone: true,
  imports: [RouterLink, ButtonModule],
  templateUrl: './access-pending.component.html',
  styleUrl: './access-pending.component.scss',
})
export class AccessPendingComponent {}
